import goto from "./index";
import getStore from "@utils/redux/store";
import {
  hasPromoCode,
  hasVipPromoCode,
  isAddonStoreEligible,
  isFastForwardEligible,
  isNoomSummitEligible,
  isProbioticsDeliveryEligible,
  isZumbaOfferEligible,
} from "@utils/userSegment/features";
import { isEnLanguage, isInApp, isUS } from "src/utils/userSegment";
import { updateForwardedParams } from "src/utils/urlParams";
import { CHECK_EMAIL_REMINDER_PARAM } from "src/components/collapsible-header/CollapsibleHeader";

// This navigates outside of the Noom Premium context
export default {
  async navigateFromNoomPremium(showEmailReminder = true) {
    const { purchasedNoomPremium } = getStore().getState().addOns;

    // baselined behavior from ex1058 - en/US promo code users are eligible for ffwd
    if ((!hasPromoCode() || isUS()) && isFastForwardEligible()) {
      goto.fastForwardTrial({
        showEmailReminder:
          purchasedNoomPremium && showEmailReminder ? "noomPremium" : null,
      });
      return;
    }

    if (isProbioticsDeliveryEligible()) {
      goto.probioticsDelivery();
      return;
    }

    if (isZumbaOfferEligible()) {
      goto.zumbaOffer();
      return;
    }

    if (isUS() && isEnLanguage()) {
      await isNoomSummitEligible.load();
    }

    if (!hasVipPromoCode() && isNoomSummitEligible()) {
      updateForwardedParams({
        [CHECK_EMAIL_REMINDER_PARAM]:
          purchasedNoomPremium && showEmailReminder ? "noomPremium" : null,
      });
      goto.layer("noom-summit");
      return;
    }

    if (!hasVipPromoCode() && isAddonStoreEligible()) {
      goto.addOns({});
      return;
    }

    if (isInApp()) {
      goto.nativePurchaseComplete();
      return;
    }

    goto.enrollment({
      showEmailReminder: purchasedNoomPremium ? "noomPremium" : null,
    });
  },
};
